import React from 'react';
import { useTranslation } from 'react-i18next';
import SystemSectionTabsLayout from '../../../shared/ui/system-section-tabs/system-section-tabs-layout.jsx';

function SystemSettingsLayout() {
  const { t } = useTranslation();
  const SYSTEM_SETTINGS_TABS = [
    { key: 'general', label: t('systemNav.generalTab'), to: '/system/settings/general' },
    { key: 'branding', label: t('systemNav.brandingTab'), to: '/system/settings/branding' },
    { key: 'tasks', label: t('systemNav.tasksTab'), to: '/system/settings/tasks' },
    { key: 'email', label: t('systemNav.emailTab'), to: '/system/settings/email' },
    { key: 'transaction-settings', label: t('systemNav.transactionSettingsTab'), to: '/system/settings/transaction-settings' },
    { key: 'verification', label: t('systemNav.verificationTab'), to: '/system/settings/verification' },
  ];
  return <SystemSectionTabsLayout tabs={SYSTEM_SETTINGS_TABS} />;
}

export default SystemSettingsLayout;
